export default {
  path: '/regulatory-ordinances/:id',
  component: () =>
    import(
      '@/components/pages/RegulatoryOrdinances/RegulatoryOrdinance.vue'
    )
}
